
import WDPanes from './wd-panes';
import WDPane from './wd-pane';

export default class WDPaneStack extends WDPane
{

  #stack;

  constructor(cfg)
  {
    super(cfg).classList.add('wd-pane-stack');

    //setup new panes in modal mode (so always 100% width)
    this.#stack = new WDPanes({ inModal: true });
  };

  connectedCallback()
  {
    super.connectedCallback();
    this.body.append(this.#stack);
  };

  cleanupCallback()
  {
    // Clean up stack
    if (this.#stack) {
      this.#stack = null;
    }

    super.cleanupCallback();
  };

  get stack() { return this.#stack; };

  pop(animated)
  {
    if (animated === undefined) animated = true;

    if (this.#stack.items().length == 1)
    {
      super.pop(animated);
    }
    else
    {
      this.#stack.pop(animated);
    }

  };

};

customElements.define('wd-pane-stack', WDPaneStack);
